// extracted by mini-css-extract-plugin
module.exports = {"bold":"_0fce717cdb--bold--1dMKK","description":"_0fce717cdb--description--YQF6C"};